import React from 'react';

const MaintenanceScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-kawaii px-4">
      <div className="max-w-md w-full text-center">
        {/* つむぎマスコット */}
        <div className="mb-8 animate-float">
          <img
            src="/tsumugi.png"
            alt="つむぎ"
            className="mx-auto w-32 h-32 md:w-40 md:h-40 drop-shadow-lg"
          />
        </div>

        {/* メインメッセージ */}
        <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-soft-lg p-8 md:p-10 border border-peach/20">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4 leading-relaxed">
            今、準備しています
          </h1>

          <p className="text-base md:text-lg text-gray-600 mb-6 leading-relaxed">
            せっかく来てくれたのに、ごめんね。<br />
            もう少しで終わるから。
          </p>

          {/* 装飾的なドット */}
          <div className="flex justify-center gap-2 mt-8">
            <div className="w-3 h-3 bg-peach rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
            <div className="w-3 h-3 bg-peach rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
            <div className="w-3 h-3 bg-peach rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
          </div>
        </div>

        {/* フッター */}
        <div className="mt-8 text-sm text-gray-500">
          <p>つむぎ - 橋本病患者向け疲労管理AI</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
